/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CBadge,
  CButton,
  CSpinner,
  CAvatar,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CAlert,
  CTooltip,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { 
  cilUser, 
  cilPhone, 
  cilEnvelopeClosed, 
  cilArrowLeft, 
  cilClock, 
  cilLockLocked, 
  cilShieldAlt,
  cilInfo,
  cilCheckCircle,
  cilXCircle,
  cilWarning,
  cilCalendar,
  cilCopy
} from '@coreui/icons';
import { getUserDetailsRequestAction, deleteUserRequestAction } from '../../store/users/usersActions';
import './UserDetails.scss';

function UserDetails(props) {
  const { getUserDetailsRequest, getUserDetailsData, getUserDetailsError, deleteUserRequest } = props;
  const { userId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('general');
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [deleteModal, setDeleteModal] = useState({ open: false, item: null });

  useEffect(() => {
    if (userId) {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const sessionUserId = localStorage.getItem('sessionUserId');
      const sessionUserIdValue = sessionUserId || userData?.sessionUserId;

      if (sessionUserIdValue && sessionUserIdValue !== 'undefined') {
        const requestData = {
          SessionUserId: String(sessionUserIdValue),
          UserId: String(userId)
        };
        getUserDetailsRequest({ data: requestData });
      }
    }

    if (location.state?.user) {
      setUserInfo(location.state.user);
    }
  }, [userId, getUserDetailsRequest, location.state]);

  useEffect(() => {
    if (getUserDetailsData || getUserDetailsError) {
      setLoading(false);
    }
  }, [getUserDetailsData, getUserDetailsError]);

  const handleGoBack = () => {
    navigate('/users');
  };

  const handleCopyUserId = async (id) => {
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  const handleEdit = () => {
    navigate(`/users/edit/${currentUser.UserId}`, {
      state: { user: currentUser }
    });
  };

  const handleDeleteClick = () => {
    setDeleteModal({ open: true, item: currentUser });
  };

  const handleDeleteConfirm = () => {
    if (deleteModal.item) {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const sessionUserId = localStorage.getItem('sessionUserId');
      const userId = sessionUserId || userData?.sessionUserId;

      if (userId && userId !== 'undefined') {
        const deleteData = {
          SessionUserId: String(userId),
          UserId: deleteModal.item.UserId,
          Status: 0,
          UserName: deleteModal.item.UserName,
          Email: deleteModal.item.Email,
          Name: deleteModal.item.Name,
          Surname: deleteModal.item.Surname,
          CepTel: deleteModal.item.CepTel || '',
          Telefon: deleteModal.item.Telefon || ''
        };
        deleteUserRequest({ data: deleteData });
        
        // Silme işlemi başarılı olduğunda kullanıcılar listesine geri dön
        setTimeout(() => {
          navigate('/users');
        }, 1000);
      } else {
        console.error('User session not found');
      }
    }
    setDeleteModal({ open: false, item: null });
  };

  const handleDeleteCancel = () => {
    setDeleteModal({ open: false, item: null });
  };

  const formatDate = (dateTime) => {
    if (!dateTime || dateTime === "0") return '-';
    
    const dateStr = String(dateTime).trim();
    
    if (dateStr.length === 16) {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      const hour = dateStr.substring(8, 10);
      const minute = dateStr.substring(10, 12);
      const second = dateStr.substring(12, 14);
      
      const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
      
      if (!isNaN(date.getTime())) {
        const utcPlus3Date = new Date(date.getTime() + (3 * 60 * 60 * 1000));
        
        return utcPlus3Date.toLocaleDateString('tr-TR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      }
    }
    
    if (dateStr.length === 14) {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      const hour = dateStr.substring(8, 10);
      const minute = dateStr.substring(10, 12);
      const second = dateStr.substring(12, 14);
      
      const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
      
      if (!isNaN(date.getTime())) {
        const utcPlus3Date = new Date(date.getTime() + (3 * 60 * 60 * 1000));
        
        return utcPlus3Date.toLocaleDateString('tr-TR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      }
    }
    
    try {
      const date = new Date(dateTime);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('tr-TR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      }
    } catch (error) {
      console.error('Date formatting error:', error);
    }
    
    return '-';
  };

  const getFullName = (user) => {
    if (!user) return '-';
    const name = user.Name || '';
    const surname = user.Surname || '';
    return `${name} ${surname}`.trim() || '-';
  };

  const getUserStatusBadge = (status) => {
    const statusMap = {
      1: { color: 'success', text: t('activeUser') || 'Aktif', icon: cilCheckCircle },
      0: { color: 'danger', text: t('inactiveUser') || 'İnaktif', icon: cilXCircle }
    };
    
    const statusInfo = statusMap[status] || { color: 'secondary', text: status, icon: cilWarning };
    return (
      <CBadge color={statusInfo.color} shape="rounded-pill" className="user-status-badge">
        <CIcon icon={statusInfo.icon} size="sm" className="me-1" />
        {statusInfo.text}
      </CBadge>
    );
  };

  const getSessionStatusBadge = (status) => {
    const statusMap = {
      1: { color: 'success', text: t('active') || 'Aktif', icon: cilCheckCircle },
      0: { color: 'secondary', text: t('inactive') || 'İnaktif', icon: cilXCircle }
    };
    
    const statusInfo = statusMap[status] || { color: 'warning', text: status, icon: cilWarning };
    return (
      <CBadge color={statusInfo.color} shape="rounded-pill" className="session-status-badge">
        <CIcon icon={statusInfo.icon} size="sm" className="me-1" />
        {statusInfo.text}
      </CBadge>
    );
  };

  const getTimeAgo = (dateTime) => {
    if (!dateTime || dateTime === "0") return '-';
    
    try {
      let date;
      const dateStr = String(dateTime).trim();
      
      // 16 karakter format (YYYYMMDDHHMISSSS) veya 14 karakter format (YYYYMMDDHHMMSS)
      if (dateStr.length === 16 || dateStr.length === 14) {
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const hour = dateStr.substring(8, 10);
        const minute = dateStr.substring(10, 12);
        const second = dateStr.substring(12, 14);
        
        date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
        
        // UTC+3 ayarlaması
        if (!isNaN(date.getTime())) {
          date = new Date(date.getTime() + (3 * 60 * 60 * 1000));
        }
      } else {
        date = new Date(dateTime);
      }
      
      if (isNaN(date.getTime())) {
        return '-';
      }
      
      const now = new Date();
      const diffInMs = now - date;
      
      // Negatif değer kontrolü
      if (diffInMs < 0) {
        return t('futureDate') || 'Gelecek tarih';
      }
      
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
      const diffInHours = Math.floor(diffInMinutes / 60);
      const diffInDays = Math.floor(diffInHours / 24);
      const diffInMonths = Math.floor(diffInDays / 30);
      const diffInYears = Math.floor(diffInDays / 365);

      if (diffInMinutes < 1) {
        return t('justNow') || 'Az önce';
      } else if (diffInMinutes < 60) {
        return `${diffInMinutes} ${t('minutesAgo') || 'dakika önce'}`;
      } else if (diffInHours < 24) {
        return `${diffInHours} ${t('hoursAgo') || 'saat önce'}`;
      } else if (diffInDays < 30) {
        return `${diffInDays} ${t('daysAgo') || 'gün önce'}`;
      } else if (diffInMonths < 12) {
        return `${diffInMonths} ${t('monthsAgo') || 'ay önce'}`;
      } else {
        return `${diffInYears} ${t('yearsAgo') || 'yıl önce'}`;
      }
    } catch (error) {
      console.error('Time ago calculation error:', error);
      return '-';
    }
  };

  const currentUser = getUserDetailsData?.User || userInfo;
  const userSessions = getUserDetailsData?.UserSessionList || [];
  const userPasswords = getUserDetailsData?.UserPasswordList || [];

  if (loading) {
    return (
      <div className="user-details-loading">
        <CSpinner color="primary" size="lg" />
        <p className="mt-3 text-muted">{t('loadingUserDetails') || 'Kullanıcı detayları yükleniyor...'}</p>
      </div>
    );
  }

  if (getUserDetailsError) {
    return (
      <div className="user-details-error">
        <CButton
          color="secondary"
          variant="outline"
          onClick={handleGoBack}
          className="mb-3"
        >
          <CIcon icon={cilArrowLeft} className="me-2" />
          {t('goBack') || 'Geri Dön'}
        </CButton>
        <CAlert color="danger" className="error-alert">
          <CIcon icon={cilXCircle} className="me-2" />
          {t('userLoadError') || 'Kullanıcı bilgileri yüklenirken bir hata oluştu.'}
        </CAlert>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="user-details-not-found">
        <CButton
          color="secondary"
          variant="outline"
          onClick={handleGoBack}
          className="mb-3"
        >
          <CIcon icon={cilArrowLeft} className="me-2" />
          {t('goBack') || 'Geri Dön'}
        </CButton>
        <CAlert color="warning" className="warning-alert">
          <CIcon icon={cilWarning} className="me-2" />
          {t('userNotFound') || 'Kullanıcı bulunamadı.'}
        </CAlert>
      </div>
    );
  }

  return (
    <div className="user-details-container">
      {/* Header */}
      <div className="user-details-header">
        <div className="header-left">
          <CButton
            color="secondary"
            variant="outline"
            onClick={handleGoBack}
            className="back-button"
          >
            <CIcon icon={cilArrowLeft} className="me-2" />
            {t('goBack') || 'Geri Dön'}
          </CButton>
          <div className="header-title">
            <h3>{t('userDetails') || 'Kullanıcı Detayları'}</h3>
            <span className="header-subtitle">{getFullName(currentUser)}</span>
          </div>
        </div>
      </div>

      {/* User Profile Card */}
      <CCard className="user-profile-card">
        <CCardBody>
          <CRow>
            <CCol lg={4} className="profile-avatar-section">
              <div className="avatar-container">
                <CAvatar 
                  color="primary" 
                  textColor="white"
                  size="xxl"
                  className="user-avatar"
                >
                  {currentUser.Name?.charAt(0)?.toUpperCase() || <CIcon icon={cilUser} size="xl" />}
                </CAvatar>
                <div className="avatar-status">
                  {getUserStatusBadge(currentUser.Status)}
                </div>
              </div>
            </CCol>
            <CCol lg={8} className="profile-info-section">
              <div className="profile-header">
                <div className="profile-name-section">
                  <h4 className="profile-name">{getFullName(currentUser)}</h4>
                  <p className="profile-username">@{currentUser.UserName}</p>
                </div>
                <div className="profile-id-section">
                  <CTooltip content={copied ? t('copied') || 'Kopyalandı!' : t('copyUserId') || 'Kullanıcı ID\'sini kopyala'}>
                    <CBadge 
                      color="info" 
                      shape="rounded-pill" 
                      className="user-id-badge"
                      onClick={() => handleCopyUserId(currentUser.UserId)}
                    >
                      <CIcon icon={cilCopy} size="sm" className="me-1" />
                      ID: {currentUser.UserId}
                    </CBadge>
                  </CTooltip>
                </div>
              </div>
              
              <div className="profile-contact-info">
                <div className="contact-item">
                  <CIcon icon={cilEnvelopeClosed} className="contact-icon" />
                  <span className="contact-text">{currentUser.Email || t('notSpecified') || 'Belirtilmemiş'}</span>
                </div>
                {(currentUser.CepTel || currentUser.Telefon) && (
                  <div className="contact-item">
                    <CIcon icon={cilPhone} className="contact-icon" />
                    <span className="contact-text">{currentUser.CepTel || currentUser.Telefon}</span>
                  </div>
                )}
                {currentUser.LastLoginDatetime && currentUser.LastLoginDatetime !== "0" && (
                  <div className="contact-item">
                    <CIcon icon={cilClock} className="contact-icon" />
                    <span className="contact-text">
                      {t('lastLogin') || 'Son giriş'}: {formatDate(currentUser.LastLoginDatetime)}
                      <small className="ms-2 text-muted">({getTimeAgo(currentUser.LastLoginDatetime)})</small>
                    </span>
                  </div>
                )}
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>

      {/* Tabs */}
      <CCard className="user-details-tabs">
        <CCardHeader className="tabs-header">
          <CNav variant="tabs" role="tablist" className="custom-tabs">
            <CNavItem>
              <CNavLink
                active={activeTab === 'general'}
                onClick={() => setActiveTab('general')}
                className="custom-tab-link"
              >
                <CIcon icon={cilUser} className="me-2" />
                {t('generalInfo') || 'Genel Bilgiler'}
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                active={activeTab === 'sessions'}
                onClick={() => setActiveTab('sessions')}
                className="custom-tab-link"
              >
                <CIcon icon={cilShieldAlt} className="me-2" />
                {t('sessions') || 'Oturumlar'} 
                {userSessions.length > 0 && (
                  <CBadge color="primary" className="ms-2 tab-badge">{userSessions.length}</CBadge>
                )}
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                active={activeTab === 'passwords'}
                onClick={() => setActiveTab('passwords')}
                className="custom-tab-link"
              >
                <CIcon icon={cilLockLocked} className="me-2" />
                {t('passwordHistory') || 'Şifre Geçmişi'}
                {userPasswords.length > 0 && (
                  <CBadge color="primary" className="ms-2 tab-badge">{userPasswords.length}</CBadge>
                )}
              </CNavLink>
            </CNavItem>
          </CNav>
        </CCardHeader>
        
        <CCardBody className="tabs-content">
          <CTabContent>
            {/* General Information Tab */}
            <CTabPane visible={activeTab === 'general'}>
              <CRow>
                <CCol lg={6}>
                  <CCard className="info-card">
                    <CCardHeader className="info-card-header">
                      <CIcon icon={cilUser} className="me-2" />
                      <h6>{t('personalInfo') || 'Kişisel Bilgiler'}</h6>
                    </CCardHeader>
                    <CCardBody>
                      <div className="info-grid">
                        <div className="info-item">
                          <label className="info-label">{t('firstName') || 'Ad'}</label>
                          <div className="info-value">{currentUser.Name || '-'}</div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('lastName') || 'Soyad'}</label>
                          <div className="info-value">{currentUser.Surname || '-'}</div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('email') || 'E-posta'}</label>
                          <div className="info-value">{currentUser.Email || '-'}</div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('mobilePhone') || 'Cep Telefonu'}</label>
                          <div className="info-value">{currentUser.CepTel || '-'}</div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('phone') || 'Telefon'}</label>
                          <div className="info-value">{currentUser.Telefon || '-'}</div>
                        </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
                
                <CCol lg={6}>
                  <CCard className="info-card">
                    <CCardHeader className="info-card-header">
                      <CIcon icon={cilInfo} className="me-2" />
                      <h6>{t('systemInfo') || 'Sistem Bilgileri'}</h6>
                    </CCardHeader>
                    <CCardBody>
                      <div className="info-grid">
                        <div className="info-item">
                          <label className="info-label">{t('userId') || 'Kullanıcı ID'}</label>
                          <div className="info-value">
                            <CBadge color="info" shape="rounded-pill" className="system-badge">
                              {currentUser.UserId}
                            </CBadge>
                          </div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('userName') || 'Kullanıcı Adı'}</label>
                          <div className="info-value">{currentUser.UserName || '-'}</div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('status') || 'Durum'}</label>
                          <div className="info-value">{getUserStatusBadge(currentUser.Status)}</div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('lastLogin') || 'Son Giriş'}</label>
                          <div className="info-value">
                            <CIcon icon={cilClock} className="me-2 text-muted" />
                            {formatDate(currentUser.LastLoginDatetime)}
                          </div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('createdDate') || 'Oluşturma Tarihi'}</label>
                          <div className="info-value">
                            <CIcon icon={cilCalendar} className="me-2 text-muted" />
                            {formatDate(currentUser.InsertDatetime)}
                          </div>
                        </div>
                        <div className="info-item">
                          <label className="info-label">{t('updatedDate') || 'Güncelleme Tarihi'}</label>
                          <div className="info-value">
                            <CIcon icon={cilCalendar} className="me-2 text-muted" />
                            {formatDate(currentUser.UpdateDatetime)}
                          </div>
                        </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CTabPane>

            {/* Sessions Tab */}
            <CTabPane visible={activeTab === 'sessions'}>
              {userSessions.length > 0 ? (
                <div className="sessions-container">
                  <div className="sessions-header">
                    <h5>{t('userSessions') || 'Kullanıcı Oturumları'}</h5>
                    <CBadge color="info" className="sessions-count">
                      {userSessions.length} {t('sessions') || 'oturum'}
                    </CBadge>
                  </div>
                  <CTable hover responsive className="sessions-table">
                    <CTableHead>
                      <CTableRow>
                        <CTableHeaderCell className="table-header">#</CTableHeaderCell>
                        <CTableHeaderCell className="table-header">{t('sessionId') || 'Oturum ID'}</CTableHeaderCell>
                        <CTableHeaderCell className="table-header">{t('status') || 'Durum'}</CTableHeaderCell>
                        <CTableHeaderCell className="table-header">{t('createdDate') || 'Oluşturma Tarihi'}</CTableHeaderCell>
                        <CTableHeaderCell className="table-header">{t('expireTime') || 'Bitiş Zamanı'}</CTableHeaderCell>
                        <CTableHeaderCell className="table-header">{t('jwt') || 'JWT Token'}</CTableHeaderCell>
                      </CTableRow>
                    </CTableHead>
                    <CTableBody>
                      {userSessions.map((session, index) => (
                        <CTableRow key={session.UserSessionId || index} className="table-row">
                          <CTableDataCell className="table-cell">{index + 1}</CTableDataCell>
                          <CTableDataCell className="table-cell">
                            <CBadge color="primary" shape="rounded-pill" className="session-id-badge">
                              {session.UserSessionId}
                            </CBadge>
                          </CTableDataCell>
                          <CTableDataCell className="table-cell">
                            {getSessionStatusBadge(session.Status)}
                          </CTableDataCell>
                          <CTableDataCell className="table-cell">
                            <div className="date-cell">
                              <CIcon icon={cilClock} className="me-2 text-muted" />
                              {formatDate(session.InsertDatetime)}
                            </div>
                          </CTableDataCell>
                          <CTableDataCell className="table-cell">
                            <div className="date-cell">
                              <CIcon icon={cilClock} className="me-2 text-muted" />
                              {formatDate(session.ExpireTime)}
                            </div>
                          </CTableDataCell>
                          <CTableDataCell className="table-cell">
                            <code className="jwt-token">
                              {session.JWT ? `${session.JWT.substring(0, 20)}...` : '-'}
                            </code>
                          </CTableDataCell>
                        </CTableRow>
                      ))}
                    </CTableBody>
                  </CTable>
                </div>
              ) : (
                <div className="empty-state">
                  <CIcon icon={cilShieldAlt} size="3xl" className="empty-icon" />
                  <h5>{t('noSessionsFound') || 'Oturum Bulunamadı'}</h5>
                  <p className="text-muted">{t('noSessionsDescription') || 'Bu kullanıcı için aktif oturum bulunmuyor.'}</p>
                </div>
              )}
            </CTabPane>

            {/* Password History Tab */}
            <CTabPane visible={activeTab === 'passwords'}>
              {userPasswords.length > 0 ? (
                <div className="passwords-container">
                  <div className="passwords-header">
                    <h5>{t('passwordHistory') || 'Şifre Geçmişi'}</h5>
                    <CBadge color="info" className="passwords-count">
                      {userPasswords.length} {t('passwords') || 'şifre'}
                    </CBadge>
                  </div>
                  <CTable hover responsive className="passwords-table">
                      <CTableHead>
                        <CTableRow>
                          <CTableHeaderCell className="table-header">#</CTableHeaderCell>
                          <CTableHeaderCell className="table-header">{t('passwordId') || 'Şifre ID'}</CTableHeaderCell>
                          <CTableHeaderCell className="table-header">{t('status') || 'Durum'}</CTableHeaderCell>
                          <CTableHeaderCell className="table-header">{t('createdDate') || 'Oluşturma Tarihi'}</CTableHeaderCell>
                          <CTableHeaderCell className="table-header">{t('createdBy') || 'Oluşturan'}</CTableHeaderCell>
                        </CTableRow>
                      </CTableHead>
                    <CTableBody>
                      {userPasswords.map((password, index) => (
                        <CTableRow key={password.UserPasswordId || index} className="table-row">
                          <CTableDataCell className="table-cell">{index + 1}</CTableDataCell>
                          <CTableDataCell className="table-cell">
                            <CBadge color="warning" shape="rounded-pill" className="password-id-badge">
                              {password.UserPasswordId}
                            </CBadge>
                          </CTableDataCell>
                          <CTableDataCell className="table-cell">
                            {getSessionStatusBadge(password.Status)}
                          </CTableDataCell>
                          <CTableDataCell className="table-cell">
                            <div className="date-cell">
                              <CIcon icon={cilClock} className="me-2 text-muted" />
                              {formatDate(password.InsertDatetime)}
                            </div>
                          </CTableDataCell>
                          <CTableDataCell className="table-cell">
                            <div className="user-cell">
                              <CIcon icon={cilUser} className="me-2 text-muted" />
                              {password.InsertUser?.UserName || '-'}
                            </div>
                          </CTableDataCell>
                        </CTableRow>
                      ))}
                    </CTableBody>
                  </CTable>
                </div>
              ) : (
                <div className="empty-state">
                  <CIcon icon={cilLockLocked} size="3xl" className="empty-icon" />
                  <h5>{t('noPasswordHistoryFound') || 'Şifre Geçmişi Bulunamadı'}</h5>
                  <p className="text-muted">{t('noPasswordHistoryDescription') || 'Bu kullanıcı için şifre geçmişi bulunmuyor.'}</p>
                </div>
              )}
            </CTabPane>
          </CTabContent>
        </CCardBody>
      </CCard>

      {/* Delete User Modal */}
      <CModal visible={deleteModal.open} onClose={handleDeleteCancel}>
        <CModalHeader>
          <CModalTitle>{t('deleteUser') || 'Kullanıcıyı Sil'}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p>{t('confirmDeleteUser') || 'Bu kullanıcıyı silmek istediğinize emin misiniz?'}</p>
          {deleteModal.item && (
            <div className="bg-light p-3 rounded">
              <strong>{t('userFullName') || 'Ad Soyad'}:</strong> {getFullName(deleteModal.item)}
              <br/>
              <strong>{t('userName') || 'Kullanıcı Adı'}:</strong> {deleteModal.item.UserName}<br/>
              <strong>{t('userEmail') || 'E-posta'}:</strong> {deleteModal.item.Email}<br/>
              <strong>ID:</strong> {deleteModal.item.UserId}
            </div>
          )}
          <p className="text-danger mt-2 mb-0">
            <small>{t('userDeleteWarning') || 'Bu işlem geri alınamaz!'}</small>
          </p>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={handleDeleteCancel}>
            {t('cancel') || 'İptal'}
          </CButton>
          <CButton color="danger" onClick={handleDeleteConfirm}>
            {t('delete') || 'Sil'}
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    getUserDetailsData: state.usersReducer?.getUserDetailsData || null,
    getUserDetailsError: state.usersReducer?.getUserDetailsError || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetailsRequest: (payload) => {
      dispatch(getUserDetailsRequestAction(payload));
    },
    deleteUserRequest: (payload) => {
      dispatch(deleteUserRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);